import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdrxdffj33: FaireProductEntity = {
  token: "p_cdrxdffj33",
  type: "product",
  name: "Sandalwood Rose– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/78718dc05df7856df2345d3dce00b97cc8fc2075cae1f1d3e9593a18005466ed.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59160f9df566702c258b87f75b05401433313b23f4e036b28f9ed5c1e0c8f0e1.jpeg",
    "https://cdn.faire.com/fastly/d891a66f05a0252eba22e233ac7550c33aeaad8a1a2263dac6dd5d7c1f08efe7.jpeg",
    "https://cdn.faire.com/fastly/d3d24770bfa5e221ef4d3de09cece8fb31905ce2f85713b1861cb3e0015f0424.jpeg",
    "https://cdn.faire.com/fastly/de17f084e6906769bafa4d230897ded659bfcb3a5a1f53ee27b1a1ced26fd09b.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "New York meets Los Angeles. Cashmere rose, oud, and sandalwood.\n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:53.925Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
